import React from 'react';

import {Breadcrumb} from './Breadcrumb.jsx';

var NavigationBar = React.createClass({
  	render: function(){
	    return(
	       	<section className="top-bar clearfix">
	      		<div className="emblem">
	      			<a href="javascript:void(0)">
	      				<img src="images/source-code-emblem.png" alt="" title="" local/>
	      			</a>
	      		</div>
	     		<Breadcrumb libName = {this.props.libName} themeName = {this.props.themeName} />
	      			<div className="buttons">
	        			{/*<MarketplaceButton />*/}
	        			<MyLibButton />
	        			<SettingsButton />
	     		 	</div>
	       	</section>
	    );
  	}
});

var MarketplaceButton = React.createClass({
  	render: function(){
	    return(
	    	<button className="btn__lg bg-very_light btn__header lib--btn tool__tip">
	    		<i className="fa fa-tag"></i> 
	    		<span>Marketplace</span> 
	    		<strong className="tool__tip--text text-capitalize">Marketplace</strong>
	    	</button>
	    );
  	}
});
var MyLibButton = React.createClass({
	handleClick: function (){
		window.location.href = "#";
	},
  	render: function(){
	    return(
	    	<button className ="btn__lg bg-very_light btn__header lib--btn tool__tip" onClick = {this.handleClick}><i className ="fa fa-book"></i> <span>Design Library</span> <strong className ="tool__tip--text text-capitalize">Design Library</strong></button>
	    );
  	}
});
var SettingsButton = React.createClass({
	handleClick: function (){
		window.location.href = "?page=Setting";
	},
  	render: function(){
	    return(
	    	<button className="btn__lg bg-white btn__header gear--btn tool__tip" onClick = {this.handleClick}>
	    		<i className="fa fa-gear"></i> 
	    		<strong className="tool__tip--text">Settings</strong>
	    	</button>
	    );
  	}
});

export {NavigationBar};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/NavigationBar.jsx
 **/